import React from "react";
import { Box, useTheme } from "@mui/material";

interface BackgroundWrapperProps {
  children: React.ReactNode;
  image?: string;
  overlayOpacity?: number;
}

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({
  children,
  image = "/bg-table-tennis.png",
  overlayOpacity = 0.85,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        backgroundImage: `url(${image})`,
        backgroundSize: "110%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        animation: "zoomBackground 20s ease-in-out infinite alternate",

        "@keyframes zoomBackground": {
          from: { backgroundSize: "110%" },
          to: { backgroundSize: "120%" },
        },

        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.default,
          opacity: overlayOpacity,
          zIndex: 0,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          flexGrow: 1, // ← permet au contenu de s’étendre naturellement si plus long
          px: 2,
          py: { xs: 4, md: 6 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default BackgroundWrapper;
